// Core
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/commonComponents/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';

// Styles
import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';

const ViewItem = (props) => {
  const { onClose, open } = props;
  const { t } = useTranslation();
  const { portfolioItem } = useSelector((store) => store.commonData);
  const dispatch = useDispatch();

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      dispatch({
        type: 'portfolioItem',
        value: null
      });
      onClose();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        className='__common_model_class'
        maxWidth={'sm'}
        fullWidth={true}
        disableEscapeKeyDown
      >
        <DialogTitle id="alert-dialog-title">
          {portfolioItem?.artTitle}
        </DialogTitle>
        <DialogContent>
          <div className='mt-2 text-center'>
            <img src={portfolioItem?.artPicture} alt="" style={{ width: '100%', height: '300px', objectFit: 'contain', marginBottom:'20px'}}/>
            <p style={{ whiteSpace: 'pre-line', textAlign:'justify' }} dangerouslySetInnerHTML={{ __html: portfolioItem?.artDescription }}></p>
          </div>
        </DialogContent>
        <DialogActions>
          <div className='d-flex align-items-center' style={{ margin: '15px' }}>
            <Button
              label={t('cancel')}
              handleOnClick={() => handleClose(false)}
            />
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViewItem;

ViewItem.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
